/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import React, { ComponentType } from 'react';
import DefaultTableVisualization, { ITableVisualizationProps } from './TableVisualization';
import { tableVisualizationConverter as defaultConverter } from './converter/tableVisualizationConverter';
import { ITableVisualizationWrapperProps } from './types/tableVisualizationTypes';
import { DataLayoutConverter, generateDataLayout as defaultGenerateDataLayout } from './converter/dataLayoutConverter';
import { IConverterResult } from './types/tableVisualizationConverterTypes';

export function TableVisualizationWrapperHOC(TableVisualization: ComponentType<ITableVisualizationProps>,
    convert: (props: ITableVisualizationWrapperProps) => IConverterResult,
    generateDataLayout: DataLayoutConverter) {

    return function TableVisualizationWrapper(props: ITableVisualizationWrapperProps) {

        const {
            dataset,
            dynamicProperties,
            staticProperties,
            linkOptions,
            handle
        } = props;

        const { table, missingIndex } = convert(props);
        const layout = generateDataLayout(staticProperties, dataset);

        if (missingIndex >= 0) {
            handle.requestDatasetUpdate(layout, Math.max(0, missingIndex - 1), 100);
        }

        return (
            <TableVisualization
                table={table}
                staticProperties={staticProperties}
                dynamicProperties={dynamicProperties}
                onUpdateDynamicProperties={handle.updateDynamicProperties}
                linkOptions={linkOptions}
            />
        );
    }
}

export const TableVisualizationWrapper = TableVisualizationWrapperHOC(DefaultTableVisualization, defaultConverter, defaultGenerateDataLayout);
